export enum FontSize {
  Regular12 = 12,
  Regular14 = 14,
  Regular16 = 16,
  Regular20 = 20,
  Regular24 = 24,
  Regular30 = 30,
}
